export const BASE_URL = 'https://api.alwalaaingroup.com';
export const BYTE_RANGE_BASE_URL = BASE_URL + '/api/file-manager/stream';

export const INNER_VERSION = '1.21.1';
export const VERSION = '3.7.1';